/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/movie/overview/desktop.app.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'movie/overview/desktop.app', exports: {} };
const exports = module.exports;



import $ from '@take-2/fd-modules/jQuery';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_dateUtil as Fandango_dateUtil_dateFromQuery } from '@take-2/fd-modules/splits/require-global';

const { dateFromQuery } = Fandango_dateUtil_dateFromQuery;


import { Fandango_eventQueue as eventQueue } from '@take-2/fd-modules/splits/require-global';



const { EventNames } = eventQueue


import { fd_location as fd_location_locationFormCreation_updateLocation_getLocation } from '@take-2/fd-modules/splits/require-global';

const { locationFormCreation, updateLocation, getLocation } = fd_location_locationFormCreation_updateLocation_getLocation;


import shared_utils_objUtils_pick from '@take-2/fd-modules/shared/utils/objUtils';

const { pick } = shared_utils_objUtils_pick;


import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import { Splide as Splide } from '@take-2/fd-modules/splits/require-core';



import { Fandango as Fandango_context_pageDetails } from '@take-2/fd-modules/splits/require-core';

const { context: { featureFlags: { permissionTrialEnabled } }, pageDetails: { allowsMopTranslation, mopUrlZip }, } = Fandango_context_pageDetails;


import global_tracking_f360_EventTypes_f360EventTypes_track_trackF360 from '@take-2/fd-modules/global/tracking/f360';

const { EventTypes: f360EventTypes, track: trackF360 } = global_tracking_f360_EventTypes_f360EventTypes_track_trackF360;


import i18n from '@take-2/fd-modules/shared/global/Fandango.i18n';



import bannerMPS from '@take-2/fd-modules/movie/shared/bannerMPS';



import calendarUI from '@take-2/fd-modules/movie/shared/calendarUI';



import features from '@take-2/fd-modules/movie/overview/features';



import headerUI from '@take-2/fd-modules/movie/overview/headerUI.desktop';



import historyStates from '@take-2/fd-modules/movie/shared/historyStates';



import marketingSpotlight from '@take-2/fd-modules/shared/desktop/marketingSpotlight';



import movieStateUI from '@take-2/fd-modules/movie/shared/desktop/movieStateUI';



import onDemandUI from '@take-2/fd-modules/movie/shared/mop.onDemandUI';



import showtimesUI from '@take-2/fd-modules/movie/shared/showtimesUI';



import videoLinksUI from '@take-2/fd-modules/movie/shared/desktop/videoLinksUI';



import worker from '@take-2/fd-modules/shared/movies/movieState.worker';



import newFanalert from '@take-2/fd-modules/movie/overview/newFanalert';



import viewToggleBtns from '@take-2/fd-modules/movie/shared/mop.viewToggleBtns';



import { shared_global_globalTooltipModule as globalTooltipModule } from '@take-2/fd-modules/splits/require-global';



const Selectors = {
    FAN_ALERT_FORM: '#fanalert-form',
    GEOLOCATION_PERMISSION: '#geolocation',
    TRANSLATE_BUTTON: '#js-translate-button',
    MOVIE_DETAIL_HEADER_REVIEW_CONTAINER: '.movie-detail-header__reviews',
    GLOBAL_TOOLTIP_MOP_PLACEHOLDER: '#global-tooltip-placeholder-mop',
    GLOBAL_TOOLTIP_ON_DEMAND_PLACEHOLDER: '#global-tooltip-placeholder-on-demand',
    GLOBAL_TOOLTIP_ON_DEMAND: '.global-tooltip__container--mop-mobile-at-home',
    VIEWING_TYPE_TOGGLE_INFO: '.js-viewing-type-toggle__info',
}


const Styles = {
    HIDE: 'hide',
}


const ViewingTypes = {
    BUY_TICKETS: 'buytickets',
}
// #region State Worker Events
function onCalendarChange(status, err, results, workerContext) {
    const { StatusTypes } = worker;
    switch (status) {
        case StatusTypes.FETCHING:
            calendarUI.busy();
            showtimesUI.busy();
            break;
        case StatusTypes.SUCCESS: {
            const { movie, movieState, movieAttribs, request: { initialRequestDate } } = workerContext;
            calendarUI.done(results, movie, movieState, movieAttribs, { initialRequestDate });
            break;
        }
        default:
            calendarUI.error(err);
            break;
    }
}
// eslint-disable-next-line no-unused-vars
function onShowtimesChange(status, err) {
    const { StatusTypes } = worker;
    switch (status) {
        case StatusTypes.FETCHING:
            showtimesUI.busy();
            break;
        case StatusTypes.SUCCESS:
            // noop: showtimes rendering wants the complete states & attribs
            break;
        default:
            showtimesUI.error(err);
            break;
    }
}
function onInTheatersDone(status, err, results, workerContext) {
    const { StatusTypes } = worker;
    if (status !== StatusTypes.SUCCESS) {
        return;
    }
    showtimesUI.done(Object.assign(pick(results, 'adobeLaunch', 'movie', 'movieAttribs', 'movieState', 'showtimes'), pick(workerContext.request, 'date')));
}
// eslint-disable-next-line no-unused-vars
function onOnDemandDone(status, err, results) {
    const { StatusTypes } = worker;
    if (status !== StatusTypes.SUCCESS) {
        return;
    }
    onDemandUI.done(Object.assign(pick(results.movie, 'id', 'genre', 'lowestStreamingPrice', 'offer', 'releaseDate', 'sluggedTitle', 'streamingServices', 'title', 'poster', 'vuduMovieId'), pick(results.movieAttribs, 'showFanalert', 'showStreaming', 'showStreamingPresale'), pick(results.adobeLaunch, 'trackingState', 'trackingAttribs'), pick(results.movieState, 'isTicketingWindow', 'isNotTicketingWindow'), {
        isDesktop: true
    }));
}
function onDone(status, err, results, workerContext) {
    viewToggleBtns.init(results);
    onOnDemandDone(status, err, results);
    onInTheatersDone(status, err, results, workerContext);
    initGlobalTooltip();
}
// #endregion
// #region Click & Child UI Events Callbacks
function onCalendarDateChange(selectedDate) {
    if (selectedDate) {
        movieStateUI.update({
            date: selectedDate,
            allowSameDateCalendarUpdate: true
        });
    }
}
function onHistoryChange(type, data) {
    if (type === historyStates.HistoryEventTypes.CALENDAR) {
        const { date, location } = data;
        updateLocation(location);
        movieStateUI.update({
            date,
            location,
            allowSameDateCalendarUpdate: true
        });
    }
}
function onLocationChange() {
    // odd thing, even though we're passed updatedLocation we need it to run through another Fandango library that sets cookies 'n such, to finally consume the data's parsed form in Fandango.util.getLocation -- this is clearly a bit brittle to say the least. need to expose the validator / parser itself, otherwise we're just trusting that the timing of eventQueue "LOCATION_OVERLAY_CLOSE" event falls to our favor. Not comfortable with that.
    worker.update({
        date: dateFromQuery('d'),
        location: getLocation(),
        allowSameDateCalendarUpdate: true
    });
}
function setupTranslator() {
    // Create button on page below movie detail header review container
    const movieDetailHeaderReviewContainer = document.querySelector(Selectors.MOVIE_DETAIL_HEADER_REVIEW_CONTAINER);
    if (movieDetailHeaderReviewContainer) {
        movieDetailHeaderReviewContainer.insertAdjacentHTML('afterend', '<button id="js-translate-button" class="btn">Traducir a Español</button>');
    }
    // Setup translator
    i18n.init(i18n.Languages.ENGLISH, i18n.Languages.SPANISH);
    // Setup translation button listener, translation API will only function on user action
    const translationButton = document.querySelector(Selectors.TRANSLATE_BUTTON);
    if (translationButton) {
        translationButton.addEventListener('click', () => {
            i18n.translate().then(r => console.log(r));
            if (!i18n.getIsTranslating()) {
                translationButton.innerHTML = 'Translate to English';
            }
            else {
                translationButton.innerHTML = 'Traducir a Español';
            }
        });
    }
}
// #endregion
function initGlobalTooltip() {
    // Check if placeholder has been placed in the MOP
    const mopPlaceholderExists = Boolean(document.querySelector(Selectors.GLOBAL_TOOLTIP_MOP_PLACEHOLDER));
    if (mopPlaceholderExists) {
        // Render tooltip under placeholder
        const tooltipOpts = {
            selector: Selectors.GLOBAL_TOOLTIP_MOP_PLACEHOLDER,
            page: globalTooltipModule.Pages.MOVIE_OVERVIEW,
            overrideClass: 'global-tooltip__container--mop-mobile-buy-tickets dark__section',
            placement: globalTooltipModule.Constants.AFTEREND
        };
        globalTooltipModule.initInline(tooltipOpts);
    }
    // Check if placeholder has been placed in the on demand container
    const onDemandPlaceholderExists = Boolean(document.querySelector(Selectors.GLOBAL_TOOLTIP_ON_DEMAND_PLACEHOLDER));
    const onDemandTooltipExists = Boolean(document.querySelector(Selectors.GLOBAL_TOOLTIP_ON_DEMAND));
    if (onDemandPlaceholderExists && !onDemandTooltipExists) {
        const renderTooltip = (hideTooltip) => {
            const styleOverride = hideTooltip ?
                'global-tooltip__container--mop-mobile-at-home dark__section viewing-type-toggle__hide' :
                'global-tooltip__container--mop-mobile-at-home dark__section';
            const tooltipOpts = {
                selector: Selectors.GLOBAL_TOOLTIP_ON_DEMAND_PLACEHOLDER,
                page: globalTooltipModule.Pages.MOVIE_OVERVIEW,
                overrideClass: styleOverride,
                placement: globalTooltipModule.Constants.AFTEREND
            };
            globalTooltipModule.initInline(tooltipOpts);
        };
        // Show / hide tooltip on first render depending on selected tab if it exists
        const currentTab = viewToggleBtns.getCurrentTab();
        const viewingTypeToggleInfoExists = Boolean(document.querySelector(Selectors.VIEWING_TYPE_TOGGLE_INFO));
        if (currentTab) {
            // Current tab exists, show / hide tooltip on first render depending on default tab
            const isBuyTickets = currentTab === ViewingTypes.BUY_TICKETS;
            // Render tooltip under on demand container
            renderTooltip(isBuyTickets);
        }
        else if (!viewingTypeToggleInfoExists) {
            // Current tab doesn't exist and movie is available;
            // determine if a tooltip has already been rendered and show / hide accordingly
            renderTooltip(mopPlaceholderExists);
        }
    }
}
function run() {
    checkDependencies(module.name, debugLog);
    trackF360(f360EventTypes.PAGE_VIEW);
    calendarUI.addDependency({ Splide });
    features.init();
    headerUI.attach();
    historyStates.attach(onHistoryChange);
    calendarUI.setOnDateChange(onCalendarDateChange);
    marketingSpotlight.init();
    videoLinksUI.attach();
    eventQueue.on(EventNames.FAN_ALERT_READY, () => {
        newFanalert.init();
        bannerMPS.insertBannerTopAd({
            hasShowtimes: false,
            selector: Selectors.FAN_ALERT_FORM
        });
        bannerMPS.displayBannerTopAd();
    });
    if (allowsMopTranslation) {
        setupTranslator();
    }
    locationFormCreation.init({ zip: mopUrlZip });
    locationFormCreation.attach(onLocationChange);
    const geolocationPermission = $(Selectors.GEOLOCATION_PERMISSION);
    if (permissionTrialEnabled
        && geolocationPermission.width()
        && window.navigator.userAgentData?.brands.some(b => b.brand === 'Google Chrome' && parseInt(b.version) >= 126)) {
        geolocationPermission.removeClass(Styles.HIDE);
    }
    movieStateUI.run({
        isDesktopMOP: true,
        bypassCalendarFetch: false,
        onCalendarChange,
        onShowtimesChange,
        onDone,
    });
}
run();
export default {  };